export const TYPOGRAPHY_VARIANT_TO_TAG_MAP = {
  displayXL: "h1",
  displayL: "h1",
  displayM: "h1",
  displayS: "h1",
  headlineL: "h1",
  headlineM: "h2",
  headlineS: "h3",
  headlineXS: "h4",
  titleL: "h2",
  titleM: "h3",
  titleS: "h4",
  titleXS: "h5",
  bodyL: "p",
  bodyM: "p",
  bodyS: "p",
  labelM: "p",
  labelS: "p",
} as const;
